<template>
	<sf-modal-layout size="qms-xxl" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<!-- <div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<h3>조회부</h3>
				</sf-card>
			</div> -->

			<div class="sf-col sf-col-24">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<div class="menu-management-content-container h-100">
						<!-- 1레벨 시작 -->
						<div class="lv1-section-container h-100">
							<sf-data-table
								ref="tableLv1"
								:columns="columnsLv1"
								:rows="badTypeLv1List"
								rowKey="code"
								height="50vh"
								:paging="false"
								:stripe="true"
								@row-click="rowClickLv1"
							>
							</sf-data-table>
						</div>

						<!-- 2레벨 시작 -->
						<div class="lv2-section-container h-100">
							<sf-data-table
								ref="tableLv2"
								:columns="columnsLv2"
								:rows="badTypeLv2List"
								rowKey="code"
								height="50vh"
								:paging="false"
								:stripe="true"
								@row-click="rowClickLv2"
							>
							</sf-data-table>
						</div>

						<!-- 3레벨 시작 -->
						<div class="lv3-section-container h-100">
							<sf-data-table
								ref="tableLv3"
								:columns="columnsLv3"
								:rows="badTypeLv3List"
								rowKey="code"
								height="50vh"
								:paging="false"
								:stripe="true"
								selection
							>
								<template v-slot:actionsRight>
									<!-- 선택 -->
									<sf-button line v-if="isButton_(scrId, 'CR')" icon="square-plue" :onClick="selRow">
										{{ getMessage_('QWCC001476') }}
									</sf-button>
								</template>
							</sf-data-table>
						</div>
					</div>
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
export default {
	props: {
		// screen: { type: String, default: '' },
		scrId: { type: String, default: '' }
	},
	async created() {
		// console.log('badTypePopup create수행');
		// this.screen = this.screenArray.get(this.scrId);
		//await this.getBadTypeCodeLv1List_();
	},
	data() {
		return {
			show: false,
			lgrpCd: '', //불량유형대분류코드
			lgrpNm: '', //불량유형대분류명
			mgrpCd: '', //불량유형중분류코드
			mgrpNm: '' //불량유형중분류명
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('QWCC001918'); //결함유형팝업
		},
		rowsLv1() {
			return this.badTypeLv1List;
		},
		rowsLv2() {
			return this.badTypeLv2List;
		},
		rowsLv3() {
			return this.badTypeLv3List;
		},
		columnsLv1() {
			return [
				{ label: this.getMessage_('QWCC001518'), prop: 'code', width: '80px' }, //불량코드
				{ label: this.getMessage_('QWCC001517'), prop: 'codeName' } //불량명
			];
		},
		columnsLv2() {
			return [
				{ label: this.getMessage_('QWCC001518'), prop: 'code', width: '80px' }, //불량코드
				{ label: this.getMessage_('QWCC001517'), prop: 'codeName' } //불량명
			];
		},
		columnsLv3() {
			return [
				{ label: this.getMessage_('QWCC001518'), prop: 'code', width: '80px' }, //불량코드
				{ label: this.getMessage_('QWCC001517'), prop: 'codeName' } //불량명
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;
			//this.onChangeParam_({ key: 'partGCd', value: 'LP' });
			this.$sf_toggleLoading(true);
			this.getBadTypeCodeLv1List_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || error.header.message
					});
					//Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			// this.setStateClear_();
		},
		close() {
			this.setBadTypePopupInit_();
			this.show = false;
		},
		reload(currentPage = 1, pageUnit = 10) {
			// if (this.$refs.userEmailPopSearchView) {
			// 	this.$refs.userEmailPopSearchView.searchList(currentPage, pageUnit);
			// }
		},
		// userGbn은 하나의 Form에 사용자 찾기가 2건이 필요할 경우 해당 값을 셋팅한다.
		sendData(sendParam, userGbn) {
			// this.$emit('SendData', sendParam, userGbn);
			this.close();
		},
		rowClickLv1(row) {
			// console.log('1번 Row 선택 >>> ', row);
			this.lgrpCd = row.code;
			this.lgrpNm = row.codeName;
			this.getBadTypeCodeLv2List_(row)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		rowClickLv2(row) {
			// console.log('2번 Row 선택 >>> ', row);
			this.mgrpCd = row.code;
			this.mgrpNm = row.codeName;
			this.getBadTypeCodeLv3List_(row)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		selRow(row) {
			//체크박스로 선택된 행이 있는지 확인
			const selectedRow = this.$refs.tableLv3.getSelectedRows();
			if (selectedRow.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			if (selectedRow.length > 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('QWCC001166')
				}); //행을 선택해 주세요. / 한건만 선택해주세요.
				return;
			}

			//선택한 1,2,3레벨 코드들
			var selCodes = {
				badTypeLgrpCd: this.lgrpCd,
				badTypeLgrpNm: this.lgrpNm,
				badTypeMgrpCd: this.mgrpCd,
				badTypeMgrpNm: this.mgrpNm,
				badTypeSgrpCd: selectedRow[0].code,
				badTypeSgrpNm: selectedRow[0].codeName
			};
			// console.log('selCodes >>> ', selCodes);
			this.$emit('SendBadTypeData', selCodes);
		}
	}
};
</script>

<style scoped>
.menu-management-content-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
.lv1-section-container {
	width: 32%;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	overflow-y: scroll;

	border-right: none;
	border-bottom: none;
	border-radius: 5px;
	border: 1px solid #8da1b9;
}
.lv2-section-container {
	width: 32%;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	overflow-y: scroll;

	border-right: none;
	border-bottom: none;
	border-radius: 5px;
	border: 1px solid #8da1b9;
}
.lv3-section-container {
	width: 36%;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	overflow-y: scroll;

	border-right: none;
	border-bottom: none;
	border-radius: 5px;
	border: 1px solid #8da1b9;
}
</style>
